import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";
import PageShell from "../components/pageShell";

const SuccessStoriesHub = () => {

    useEffect(() => {
        AOS.refresh();
    }, [])

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Success Stories - Flyby Shine</title>
                        <meta name="description" content="Explore our client success stories showcasing how Flyby Shine's drone cleaning technology has transformed cleaning operations across various industries." />
                        <meta name="keywords" content="Drone Cleaning Success Stories, Case Studies, Client Results, Tank Terminal Cleaning, Federal Defense Contractor, State Agency Building, Time Savings, Cost Reduction, Operational Efficiency, Drone Technology Solutions" />
                        <meta property="og:image" content="/assets/industrialAfter.png" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <div style={{
                    height: '30vh',
                    minHeight: '320px'
                }} className="core-header vivify fadeIn duration-300 delay-100 inline-header-core">
                    <span>Our Impact</span>
                    <h1>Success Stories</h1>
                    <p>Real results for real clients. See how our drone technology is redefining industry standards.</p>
                </div>
                <div data-aos="fade-up" data-aos-delay="300">
                    <div className="service-cards-list" style={{ marginTop: 75, justifyContent: 'center' }}>
                        <Link to="/tank-terminal" style={{ paddingBottom: 20 }} className="service-card">
                            <img src="/assets/tank.jpeg" alt="A drone cleaning a tank terminal" />
                            <h2>Tank Terminal - Sunshine, Louisiana</h2>
                            <p>With Flyby Shine's drones, tank cleaning dropped from four men over four days to a two-person, one day job.</p>
                        </Link>
                        <Link to="/defense-contractor" style={{ paddingBottom: 20 }} className="service-card">
                            <img src="/assets/federaldefensecontractor.png" alt="A drone cleaning a federal defense contractor facility" />
                            <h2>Federal Defense Contractor - Confidential Location</h2>
                            <p>A high-security defense plant had one shutdown day for exterior cleaning, we rapid deployed drones to get it done with zero disruption.</p>
                        </Link>
                        <Link to="/state-agency" style={{ paddingBottom: 20 }} className="service-card">
                            <img src="/assets/stateagencybuilding.jpeg" alt="A drone cleaning a state agency building" />
                            <h2>State Agency Building - Jackson, MS</h2>
                            <p>Our two-man drone crew cleaned the Jackson state agency's windows in four pre-dawn hours, replacing a two-week, damage-prone lift job and saving time.</p>
                        </Link>
                    </div>
                </div>

                <div className="success-stories-overview" data-aos="fade-up">
                    <div className="overview-container">
                        <h2>The Flyby Shine Difference</h2>
                        <p>Our success stories demonstrate the transformative impact of drone technology across different industries and scenarios. From government facilities to industrial sites, our approach consistently delivers:</p>

                        <div className="benefits-grid">
                            <div className="benefit-item">
                                <i className="material-icons">schedule</i>
                                <h3>Time Efficiency</h3>
                                <p>Reducing cleaning times by up to 90% compared to traditional methods.</p>
                            </div>
                            <div className="benefit-item">
                                <i className="material-icons">savings</i>
                                <h3>Cost Reduction</h3>
                                <p>Minimizing labor costs and eliminating expensive equipment rentals.</p>
                            </div>
                            <div className="benefit-item">
                                <i className="material-icons">security</i>
                                <h3>Enhanced Safety</h3>
                                <p>Eliminating the need for workers at heights and reducing workplace risks.</p>
                            </div>
                            <div className="benefit-item">
                                <i className="material-icons">eco</i>
                                <h3>Minimal Impact</h3>
                                <p>Zero damage to property, landscaping, and surrounding environments.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <Contact />
            </PageShell>
            <Footer />

            <style>
                {`
                    .success-stories-overview {
                        padding: 60px 0;
                        background-color: #f9f9f9;
                        margin: 80px 0 0;
                    }
                    
                    .overview-container {
                        max-width: 1200px;
                        margin: 0 auto;
                        padding: 0 20px;
                    }
                    
                    .overview-container h2 {
                        text-align: center;
                        margin-bottom: 20px;
                        font-size: 32px;
                        color: var(--main-color);
                    }
                    
                    .overview-container > p {
                        text-align: center;
                        max-width: 800px;
                        margin: 0 auto 40px;
                        font-size: 16px;
                        line-height: 1.6;
                        font-family: 'Open Sans', sans-serif;
                    }
                    
                    .benefits-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                        gap: 30px;
                    }
                    
                    .benefit-item {
                        background-color: white;
                        padding: 30px;
                        text-align: center;
                        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
                        transition: transform 0.3s ease;
                    }
                    
                    .benefit-item:hover {
                        transform: translateY(-5px);
                    }
                    
                    .benefit-item i {
                        font-size: 40px;
                        color: var(--main-color);
                        margin-bottom: 15px;
                    }
                    
                    .benefit-item h3 {
                        font-size: 20px;
                        margin-bottom: 10px;
                    }
                    
                    .benefit-item p {
                        font-size: 14px;
                        line-height: 1.5;
                        font-family: 'Open Sans', sans-serif;
                    }
                    
                    @media (max-width: 768px) {
                        .benefits-grid {
                            grid-template-columns: 1fr;
                        }
                    }
                `}
            </style>
        </>
    )
}

export default SuccessStoriesHub;
